__webpack_require__.p = "/wp-content/themes/devster_shop/public/dist/";